var map = {
	"./allan-luik.json": 74,
	"./brien-thompson.json": 75,
	"./di-dang.json": 76,
	"./elly-searle.json": 77,
	"./mike-berg.json": 78,
	"./ona-anicello.json": 79,
	"./rajesh-kalindindi.json": 80,
	"./shufan-susan-wen.json": 81,
	"./yuriy-zaremba.json": 82
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73;